import React from 'react';
import FuseSplashScreen from '@fuse/core/FuseSplashScreen';
import * as userActions from 'app/auth/store/actions';
import * as Actions from 'app/store/actions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import AuthService from 'app/services/authService';
import { useState, useEffect } from 'react';
import { getProfilePhoto } from '../../@fuse/utils/utils';

function Auth(props) {
	const [waitAuthCheck, setWaitAuthCheck] = useState(true);

	useEffect(() => {
		async function validateLogin() {
			const authService = new AuthService();
			const user = await authService.getUser();
			if (user) {
				props.loginSuccess(user);
				props.fetchProfile({ userId: user.profile.sub });
			} else {
				authService.loginRedirect();
			}
		}
		validateLogin();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		if (props.profile.id) {
			props.setUserData({
				role: [],
				data: {
					...props.profile,
					photoURL: getProfilePhoto(props.profile.email),
					shortcuts: ['calendar', 'mail', 'contacts', 'todo']
				}
			});
			setWaitAuthCheck(false);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [props.profile]);

	return waitAuthCheck ? <FuseSplashScreen /> : <>{props.children}</>;
}

function mapDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			logoutUser: userActions.logoutUser,
			loginSuccess: userActions.loginSuccess,
			loginFailure: userActions.loginFailure,
			logout: userActions.logout,
			setUserData: userActions.setUserData,
			showMessage: Actions.showMessage,
			hideMessage: Actions.hideMessage,
			fetchProfile: Actions.fetchProfile
		},
		dispatch
	);
}

function mapStateToProps(state) {
	return {
		profile: state.profile.profile.data
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(Auth);
